// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailLogoUploader-space1-JtXZq {
	margin-bottom: 6px !important;
}

.EmailLogoUploader-space2-q57jx {
	margin-bottom: 12px !important;
}

.EmailLogoUploader-space3-gYd0M {
	margin-bottom: 18px !important;
}

.EmailLogoUploader-space4-JxvJP {
	margin-bottom: 24px !important;
}

.EmailLogoUploader-space5-Je3Yo {
	margin-bottom: 30px !important;
}

.EmailLogoUploader-space6-wWVor {
	margin-bottom: 36px !important;
}

.EmailLogoUploader-space7-dTSt4 {
	margin-bottom: 42px !important;
}

.EmailLogoUploader-space8-LPSd2 {
	margin-bottom: 48px !important;
}

.EmailLogoUploader-spaceTop1-H7Kbv {
	margin-top: 6px !important;
}

.EmailLogoUploader-spaceTop2-CwW1u {
	margin-top: 12px !important;
}

.EmailLogoUploader-spaceTop3-iSc7j {
	margin-top: 18px !important;
}

.EmailLogoUploader-spaceTop4-RD68D {
	margin-top: 24px !important;
}

.EmailLogoUploader-spaceTop5-YNZvi {
	margin-top: 30px !important;
}

.EmailLogoUploader-spaceTop6-owxd2 {
	margin-top: 36px !important;
}

.EmailLogoUploader-spaceTop7-VpRuQ {
	margin-top: 42px !important;
}

.EmailLogoUploader-spaceTop8-ffJ7T {
	margin-top: 48px !important;
}

.EmailLogoUploader-noMargin-vo7j7 {
	margin: 0px !important;
}

.EmailLogoUploader-padding1-cxhkS {
	padding-bottom: 6px !important;
}

.EmailLogoUploader-padding2-s0xr1 {
	padding-bottom: 12px !important;
}

.EmailLogoUploader-padding3-NdQ7p {
	padding-bottom: 18px !important;
}

.EmailLogoUploader-padding4-Hrrg9 {
	padding-bottom: 24px !important;
}

.EmailLogoUploader-padding5-tWLQ8 {
	padding-bottom: 30px !important;
}

.EmailLogoUploader-padding6-DFSEX {
	padding-bottom: 36px !important;
}

.EmailLogoUploader-padding7-zBPCN {
	padding-bottom: 42px !important;
}

.EmailLogoUploader-paddingTop1-ps4Va {
	padding-top: 6px !important;
}

.EmailLogoUploader-paddingTop2-lYG1j {
	padding-top: 12px !important;
}

.EmailLogoUploader-paddingTop3-jPwMO {
	padding-top: 18px !important;
}

.EmailLogoUploader-paddingTop4-zCa5Z {
	padding-top: 24px !important;
}

.EmailLogoUploader-paddingTop5-GgO_C {
	padding-top: 30px !important;
}

.EmailLogoUploader-paddingTop6-bY0JN {
	padding-top: 36px !important;
}

.EmailLogoUploader-paddingTop7-n2uCI {
	padding-top: 42px !important;
}

.EmailLogoUploader-noPadding-kTO40 {
	padding: 0px !important;
}

.EmailLogoUploader-spaceMarginBottom0-Kel4m {
	margin-bottom: 0;
}

.EmailLogoUploader-textBold-OserP {
	font-weight: 500 !important;
}

.EmailLogoUploader-textBolder-ObCsv {
	font-weight: 700 !important;
}

.EmailLogoUploader-textNormal-WRBmp {
	font-weight: normal !important;
}

/*New Design Text Colors */

.EmailLogoUploader-textDarkBlue-JH7jx {
	color: rgb(20, 39, 94) !important;
}

.EmailLogoUploader-textLightBlue-lwApj {
	color: rgb(57, 87, 106) !important;
}

.EmailLogoUploader-textLightSandleGreen-cBgnM {
	color: rgb(76, 86, 41) !important;
}

.EmailLogoUploader-textLightBrown-IeTHl {
	color: rgb(115, 79, 33) !important;
}

.EmailLogoUploader-textMediumMaroon-cYUZi {
	color: rgb(87, 37, 51) !important;
}

.EmailLogoUploader-textBrown-tuBWy {
	color: rgb(160, 47, 24) !important;
}

.EmailLogoUploader-textMaroon-pPvTy {
	color: rgb(155, 49, 67) !important;
}

.EmailLogoUploader-textDarkBrown-QtpIt {
	color: rgb(83, 18, 16) !important;
}

.EmailLogoUploader-textMediumBrown-IZVjL {
	color: rgb(142, 28, 10) !important;
}

.EmailLogoUploader-textSkyBlue-IvazW {
	color: rgb(37, 117, 141) !important;
}

.EmailLogoUploader-textGray-Yr1L8 {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EmailLogoUploader-space1-JtXZq`,
	"space2": `EmailLogoUploader-space2-q57jx`,
	"space3": `EmailLogoUploader-space3-gYd0M`,
	"space4": `EmailLogoUploader-space4-JxvJP`,
	"space5": `EmailLogoUploader-space5-Je3Yo`,
	"space6": `EmailLogoUploader-space6-wWVor`,
	"space7": `EmailLogoUploader-space7-dTSt4`,
	"space8": `EmailLogoUploader-space8-LPSd2`,
	"spaceTop1": `EmailLogoUploader-spaceTop1-H7Kbv`,
	"spaceTop2": `EmailLogoUploader-spaceTop2-CwW1u`,
	"spaceTop3": `EmailLogoUploader-spaceTop3-iSc7j`,
	"spaceTop4": `EmailLogoUploader-spaceTop4-RD68D`,
	"spaceTop5": `EmailLogoUploader-spaceTop5-YNZvi`,
	"spaceTop6": `EmailLogoUploader-spaceTop6-owxd2`,
	"spaceTop7": `EmailLogoUploader-spaceTop7-VpRuQ`,
	"spaceTop8": `EmailLogoUploader-spaceTop8-ffJ7T`,
	"noMargin": `EmailLogoUploader-noMargin-vo7j7`,
	"padding1": `EmailLogoUploader-padding1-cxhkS`,
	"padding2": `EmailLogoUploader-padding2-s0xr1`,
	"padding3": `EmailLogoUploader-padding3-NdQ7p`,
	"padding4": `EmailLogoUploader-padding4-Hrrg9`,
	"padding5": `EmailLogoUploader-padding5-tWLQ8`,
	"padding6": `EmailLogoUploader-padding6-DFSEX`,
	"padding7": `EmailLogoUploader-padding7-zBPCN`,
	"paddingTop1": `EmailLogoUploader-paddingTop1-ps4Va`,
	"paddingTop2": `EmailLogoUploader-paddingTop2-lYG1j`,
	"paddingTop3": `EmailLogoUploader-paddingTop3-jPwMO`,
	"paddingTop4": `EmailLogoUploader-paddingTop4-zCa5Z`,
	"paddingTop5": `EmailLogoUploader-paddingTop5-GgO_C`,
	"paddingTop6": `EmailLogoUploader-paddingTop6-bY0JN`,
	"paddingTop7": `EmailLogoUploader-paddingTop7-n2uCI`,
	"noPadding": `EmailLogoUploader-noPadding-kTO40`,
	"spaceMarginBottom0": `EmailLogoUploader-spaceMarginBottom0-Kel4m`,
	"textBold": `EmailLogoUploader-textBold-OserP`,
	"textBolder": `EmailLogoUploader-textBolder-ObCsv`,
	"textNormal": `EmailLogoUploader-textNormal-WRBmp`,
	"textDarkBlue": `EmailLogoUploader-textDarkBlue-JH7jx`,
	"textLightBlue": `EmailLogoUploader-textLightBlue-lwApj`,
	"textLightSandleGreen": `EmailLogoUploader-textLightSandleGreen-cBgnM`,
	"textLightBrown": `EmailLogoUploader-textLightBrown-IeTHl`,
	"textMediumMaroon": `EmailLogoUploader-textMediumMaroon-cYUZi`,
	"textBrown": `EmailLogoUploader-textBrown-tuBWy`,
	"textMaroon": `EmailLogoUploader-textMaroon-pPvTy`,
	"textDarkBrown": `EmailLogoUploader-textDarkBrown-QtpIt`,
	"textMediumBrown": `EmailLogoUploader-textMediumBrown-IZVjL`,
	"textSkyBlue": `EmailLogoUploader-textSkyBlue-IvazW`,
	"textGray": `EmailLogoUploader-textGray-Yr1L8`
};
module.exports = ___CSS_LOADER_EXPORT___;
